/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BookingRewardAuditKey } from './BookingRewardAuditKey';
import {
    BookingRewardAuditKeyFromJSON,
    BookingRewardAuditKeyFromJSONTyped,
    BookingRewardAuditKeyToJSON,
    BookingRewardAuditKeyToJSONTyped,
} from './BookingRewardAuditKey';

/**
 *
 * @export
 * @interface BookingRewardAuditRequest
 */
export interface BookingRewardAuditRequest {
    /**
     *
     * @type {Array<BookingRewardAuditKey>}
     * @memberof BookingRewardAuditRequest
     */
    keys: Array<BookingRewardAuditKey>;
}

/**
 * Check if a given object implements the BookingRewardAuditRequest interface.
 */
export function instanceOfBookingRewardAuditRequest(value: object): value is BookingRewardAuditRequest {
    if (!('keys' in value) || value['keys'] === undefined) return false;
    return true;
}

export function BookingRewardAuditRequestFromJSON(json: any): BookingRewardAuditRequest {
    return BookingRewardAuditRequestFromJSONTyped(json, false);
}

export function BookingRewardAuditRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): BookingRewardAuditRequest {
    if (json == null) {
        return json;
    }
    return {

        'keys': ((json['keys'] as Array<any>).map(BookingRewardAuditKeyFromJSON)),
    };
}

export function BookingRewardAuditRequestToJSON(json: any): BookingRewardAuditRequest {
    return BookingRewardAuditRequestToJSONTyped(json, false);
}

export function BookingRewardAuditRequestToJSONTyped(value?: BookingRewardAuditRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {

        'keys': ((value['keys'] as Array<any>).map(BookingRewardAuditKeyToJSON)),
    };
}

